export const abpStore_NS = 'abpStore';
export const layoutStore_NS = 'layoutStore';
export const customsFormStore_NS = 'customsFormStore';
